import client, { PRIVATE_CLIENT } from '../../services/client';
import sessionStore from '../../store/session';

export const getBalance = async () => {
    const response = await client.get('users/balance/', PRIVATE_CLIENT);
    sessionStore.setBalance(response.balance);
};

export const getReceivingNumbers = async () => {
    const response = await client.get(
        'receiver_numbers/receiving_numbers/',
        PRIVATE_CLIENT
    );
    return response;
};

export const getReceivingLines = async (public_key, receiver) => {
    const response = await client.post('telephony/crm/receiver-line/', PRIVATE_CLIENT, {
        public_key,
        receiver,
    });

    return response;
};

export const fetchTeamMembers = async business_number_id => {
    const response = await client.get("receiver_numbers/",
        PRIVATE_CLIENT,
        null,
        {business_number: business_number_id}
    );
    return response;
};